import { Link } from 'react-router-dom';
import msg from './msg.jfif';
import {toast} from 'react-toastify';
import {useState} from'react';
import { useNavigate} from 'react-router-dom';
import { loadDummy, setCurrentUser } from './redux/chatSlice';
import {useDispatch} from 'react-redux';
import nolan2 from './nolan2.jpg';
import nolan1 from './nolan1.jpg';
import unknown from './unknown.jpg';
import download1 from './download1.jpg';
import plant1 from './plant1.jpg';

function Login(){
 const[user,setUser]=useState({username:'',password:''});
     const navigate=useNavigate();
     const dispatch=useDispatch();
const handleChange=async(e)=>{  
const {name,value}=e.target;
setUser((prev)=>({
    ...prev,
    [name]:value
}));
};
const handlesubmit=(e)=>{
        e.preventDefault();
//user list
const users=JSON.parse(localStorage.getItem('users'))||[];
const loginUser=users.find(u=>u.username===user.username && u.password===user.password);
if(loginUser){
    toast.success(' Login successfully');
    const updatedUser={
    ...loginUser,
    profileImg:unknown,
    name:loginUser.name
}
//dummy
const dummyPosts=[
{
id:'1',
username:'@maltimarien',
text:'Hello everyone',
date:'12 Jan Sat 2026',
profileImg:nolan2,
image:download1,
likes:0,
comments:0,
retweets:0,
userLiked: false,
userCommented :false,
userRetweeted:false,
retweetFrom:null
},
{
id:'2',
username:'@nolan',
text:'Hello folks,enjoyed and honoured with captives yesterday!',
date:'20 Oct Sat 2026',
profileImg:nolan1,
image:plant1,
likes:0,
comments:0,
retweets:0,
userLiked: false,
userCommented :false,
userRetweeted:false,
retweetFrom:null
},
];
dispatch(setCurrentUser(updatedUser));
dispatch(loadDummy(dummyPosts));
localStorage.setItem('currentUser',JSON.stringify(updatedUser));
setUser({username:'',password:''});
navigate('/chat');
}
else{
     toast.error('Invalid credentials');
};
};
    return(
<div className='parent'>
<div className='coverpage'>
<img src={msg}/>
</div>
<div  className='flu' style={{width:'80%'}}>
<h4>Log in</h4>
<input type='text' name='username' value={user.username} onChange={handleChange} placeholder="Username" style={{marginTop:'12px',width:'368px',padding:'4px'}}/>
<br/>
<input type='password' name='password' placeholder="password" value={user.password} onChange={handleChange}style={{marginTop:'12px',width:'368px',padding:'4px'}}/>
<br/>
<button className='btn btn-dark'style={{marginTop:'20px'}} onClick={handlesubmit}>Login</button>
<br/>
<span style={{display:'inline-block',marginTop:'10px'}}>Couldn't have an account? or</span><Link to='/'style={{paddingLeft:'5px',whiteSpace:'nowrap'}}>Signup here</Link>
</div>
    </div>
    )
}
export default Login;
